/**
 * Three shapes are tolerated because three exist: the standard `ErrorResponse`
 * (`{errors: [{attribute?, detail}]}`), `{error: "..."}` from clinical quality
 * scores, and a bare string array from payroll. Null rather than a default
 * message, so each caller supplies copy that fits its surface.
 */
export function extractApiErrorDetails(error: unknown): string | null {
  if (!error || typeof error !== 'object') return null

  const body = error as Record<string, unknown>
  if (typeof body['error'] === 'string') return body['error']

  const errors = body['errors']
  if (typeof errors === 'string') return errors
  if (!Array.isArray(errors) || errors.length === 0) return null

  const details = errors
    .map((entry) => {
      if (typeof entry === 'string') return entry
      const record = entry as Record<string, string>
      return record['detail'] ?? record['message']
    })
    .filter(Boolean)

  return details.length > 0 ? details.join('. ') : null
}
